export default {
  createView: 'invoices-add',
  importView: 'invoices-import',
};
